import { NgModule } from '@angular/core';
import { berichtsVorlagenQueryModule, VorlagenQueryModule, VorlageQueryModule } from '.';

@NgModule({
  declarations: [],
  imports: [berichtsVorlagenQueryModule, VorlageQueryModule, VorlagenQueryModule],
  exports: [berichtsVorlagenQueryModule, VorlageQueryModule, VorlagenQueryModule],
})
export class TexteQuerysModule {}
